import { Component, OnInit } from '@angular/core';
import { LocalStorage } from '@ngx-pwa/local-storage';
import { User } from '../../models/user.model';
import { AuthUserService } from '../../services/appInitialization/authUser.service';
import { environment } from '../../../environments/environment';
import { CookieService } from 'ngx-cookie-service';


@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css']
})
export class NavbarComponent implements OnInit {
  currentUser:User;
  logoutUrl:string;
  loginUrl:string;
  GAUrl:string;
  constructor(protected localStorage: LocalStorage,private authUser: AuthUserService,private cookieService: CookieService) { }

  ngOnInit() {
    
    this.currentUser = this.authUser._user;
    this.logoutUrl = environment.logoutUrl;
    this.loginUrl = environment.loginUrl;
    this.GAUrl = environment.GAUrl;

  }

  onNavigation() {
    // clear local storage items
    this.localStorage.clear().subscribe(() => {});
    this.cookieService.set('AuthTrackerCookie','',-1,'/');
    

  }

  toggleMenu(button: any, subMenu: any) {
    const btn = document.getElementsByName(button)[0];
    const menu = document.getElementById(subMenu);
    if(btn.getAttribute("aria-expanded") == "false") {
      btn.setAttribute("aria-expanded", "true")
      menu.hidden = false;
    }
    else {
      btn.setAttribute("aria-expanded", "false");
      menu.hidden = true;
    }
  }
}
